// src/lib/canvas/item-types.ts
var ItemTypes = {
  CREATED_TEXT: "created_text",
  CREATED_IMAGE: "created_image",
  CREATED_VIDEO: "created_video",
  TEXT_FILE: "text_file",
  IMAGE_FILE: "image_file",
  SIDEBAR_FILE: "sidebar_file",
  /** A tool dragged out of the toolbar catalogue onto a canvas. */
  CANVAS_TOOL: "canvas_tool"
};

export {
  ItemTypes
};
//# sourceMappingURL=chunk-IX3ZB4XQ.js.map